// extracted by mini-css-extract-plugin
module.exports = {"Dropdown":"styles_Dropdown__KrlWr","MenuLinks":"styles_MenuLinks__T__Ia","DropdownItemMenu":"styles_DropdownItemMenu__rASjj"};